module.exports = __webpack_public_path__ + "img/logo.b63ff3bf.png";